/**
 * GlobalChatSystem Constants
 *
 * Centralized constants for the chat system.
 */

/**
 * Warning balance threshold in USD.
 * When user's OLV balance is worth less than this amount,
 * a warning banner is shown but user can still run tasks.
 * Calculated in real-time from OLV balance * current OLV rate.
 */
export const WARNING_BALANCE_THRESHOLD_USD = 10.00;

/**
 * Critical/blocking balance threshold in USD.
 * When the user's balance is AT OR BELOW this amount, the chat input is
 * blocked (in production mode only); in testing mode, only a warning shows.
 *
 * 2026-08-14: aligned with the server's hard balance stop — work pauses at
 * EMPTY ($0), not at the legacy $3 buffer. Only useLowBalanceWarning consumes
 * this constant (the comparison there is `<=`).
 */
export const CRITICAL_BALANCE_THRESHOLD_USD = 0.00;

/**
 * @deprecated Use CRITICAL_BALANCE_THRESHOLD_USD instead.
 * Kept for backward compatibility.
 */
export const LOW_BALANCE_THRESHOLD_USD = CRITICAL_BALANCE_THRESHOLD_USD;

/**
 * How long the touch message-stepper stays awake after the last scroll or
 * step before fading back out (2026-08 reading-comfort round).
 *
 * Long enough to reach for the control you just saw appear; short enough that
 * a thread you've stopped scrolling is never left with buttons sitting over
 * the text — the failure mode that got the phone pagers removed on
 * 2026-08-14.
 */
export const NAV_CLUSTER_SLEEP_MS = 2400;
